import { Controller } from "@hotwired/stimulus"

// In theory we should be able to force a GET form to submit in Turbo style using data-turbo-stream.
// In practice this doesn't seem to work, so we use this controller as a workaround.
//
// Usage:
// - Add data-controller="turbo-get" to a <form>
// - Optionally add data-debounce="500" to submit only once every 500 milliseconds (or other number)
export default class extends Controller {
  connect() {
    this.debounceTime = parseInt(this.element.getAttribute('data-debounce') || '0');
    const handler = this.debounce(this.handleSubmit.bind(this), this.debounceTime);
    this.element.addEventListener('submit', (e) => { e.preventDefault(); handler() });
  }

  handleSubmit(e) {
    let httpRequest = new XMLHttpRequest();

    let formData = new FormData(this.element);
    let search = new URLSearchParams(formData);
    let url = this.element.getAttribute('action') + '?' + search
    httpRequest.open("GET", url);

    httpRequest.onreadystatechange = () => {
      if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 200) {
          Turbo.renderStreamMessage(httpRequest.responseText);
        }
      }
    }

    httpRequest.send();
  }

  debounce(func, delay) {
    let debounceTimer
    return function () {
      // console.log("debounce called");
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(
        () => {
          // console.log("debounce proceeding");
          func.apply(context, args);
        },
        delay
      );
    }
  }
}